import axios from "axios";

export default {
	getPendingUser(id) {
		return axios.get(`/v3/pending_user/${id}`);
	},

	listPendingUsers(ctx) {
		return axios.get("/v3/pending_users", { params: ctx });
	},

	listPendingUsersPrefilled(ctx) {
		return axios.get("/v3/pending_users/prefilled", { params: ctx });
	},

	approveUser(id) {
		return axios.post(`/v3/pending_user/${id}/approve`);
	},

	denyUser(id) {
		return axios.post(`/v3/pending_user/${id}/deny`);
	}
};



// WEBPACK FOOTER //
// ./src/services/PendingUserService.js